export interface ExportDocumentPdfConfig {
	printCustomFields?: boolean;
	printCosts?: boolean;
	printPrices?: boolean;
	company?: string;
	taxIdNo?: string;
	organization?: string;
}

export enum DocumentPdfEntity {
	PURCHASE = "PURCHASE",
	ORDER = "ORDER",
}

export enum DocumentPdfDefaultColumn {
	POSITION = "position",
	NAME = "name",
	VOLUME = "volume",
	QUANTITY = "quantity",
	TOTAL_VOLUME = "total_volume",
	TAX = "tax",
}

export enum DocumentPdfAdditionalColumn {
	COST = "cost",
	UNIT_COST = "unit_cost",
	PRICE = "price",
	UNIT_PRICE = "unit_price",
}

export type DocumentPdfColumn = DocumentPdfAdditionalColumn | DocumentPdfDefaultColumn;
